import { formatDateFromIso, getDateAndTimeFromIso, formatTimeFromIso } from './dateFormatters';
import {
  TimeSlot as FormattedTimeSlot,
  TimeWindow as FormattedTimeWindow
} from '../contexts/transferSchedule/transferSchedule.types';
import {
  TimeSlot as RawTimeSlot,
  TimeWindow as RawTimeWindow
} from '../services/purchase-manager-api.types';

export const formatTimeSlots = (timeslots: RawTimeSlot[]) =>
  timeslots.reduce((formattedTimeslots: FormattedTimeSlot[], timeslot) => {
    const { optionId, routeId, localStartTimeIso, utcStartTime } = timeslot;
    const { date, time } = getDateAndTimeFromIso(localStartTimeIso);
    const slot = { optionId, routeId, time, utcStartTime };
    const dateIndex = formattedTimeslots.findIndex(slot => slot.date === date);

    if (dateIndex !== -1) {
      formattedTimeslots[dateIndex].times.push(slot);
    } else {
      formattedTimeslots.push({ date, isoDate: localStartTimeIso, times: [slot] });
    }

    return formattedTimeslots;
  }, []);

export const formatTimeWindows = (timeWindows: RawTimeWindow[]) =>
  timeWindows.reduce((formattedTimeWindows: FormattedTimeWindow[], timeWindow) => {
    const { optionId, routeId, windowStartTimeIso, windowEndTimeIso, utcStartTime } = timeWindow;

    const { date, time } = getDateAndTimeFromIso(windowStartTimeIso);
    const endRange = formatTimeFromIso(windowEndTimeIso);

    const window = { optionId, routeId, time, utcStartTime, endRange };
    const dateIndex = formattedTimeWindows.findIndex(window => window.date === date);

    if (dateIndex !== -1) {
      formattedTimeWindows[dateIndex].times.push(window);
    } else {
      formattedTimeWindows.push({ date, isoDate: windowStartTimeIso, times: [window] });
    }

    return formattedTimeWindows;
  }, []);

export const getPreferredTimeslotIndex = (
  preferredDateIso: string,
  timeslots: FormattedTimeSlot[]
) => {
  const preferredDate = formatDateFromIso(preferredDateIso.substring(0, 11));
  const preferredTimeslot = timeslots.find(ts => ts.date === preferredDate);

  return preferredTimeslot ? timeslots.indexOf(preferredTimeslot) : -1;
};
